// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:46:18

export default {
  "id": "chessfield",
  "slug": "chessfield",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a0383d2637904f0ea9e8b837b9c8acd1-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a0383d2637904f0ea9e8b837b9c8acd1/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "ChessField",
      "description": "Master chess piece movements in ChessField! Navigate a 2D grid using classic chess rules—rooks move straight, bishops diagonally, and more. But there’s a twist: moving up also makes your piece fall!\n\nChallenge Your Mind:\nStart with simple levels to learn the mechanics, then tackle increasingly tricky puzzles. Think strategically and solve creative challenges to advance!",
      "instructions": "Move your piece following chess rules—rooks move straight, bishops diagonally, etc.\nRemember: moving up also makes your piece fall down.\nSolve puzzles by reaching the goal while avoiding obstacles.\nThink strategically to complete increasingly difficult levels!",
      "genres": [
        "Boardgames"
      ],
      "tags": [
        "checkers",
        "chess"
      ]
    },
    "zh-CN": {
      "title": "棋盘",
      "description": "在ChessField中掌握棋子移动技巧！使用经典的棋盘规则在2D网格中移动——车走直线，象走斜线，还有更多。但有一个转折：向上移动也会让您的棋子落下！\n\n挑战您的思维：\n从简单的关卡开始学习机制，然后解决越来越棘手的谜题。战略思考，解决创意挑战以取得进步！",
      "instructions": "按照国际象棋规则移动您的棋子——车直线移动，象斜线移动等。\n记住：向上移动也会使您的棋子下落。\n通过到达目标同时避开障碍来解决问题。\n战略思考以完成越来越困难的关卡！",
      "genres": [
        "桌面游戏"
      ],
      "tags": [
        "跳棋",
        "国际象棋"
      ]
    },
    "zh-TW": {
      "title": "棋盤",
      "description": "在 ChessField 中精通棋子移動！使用經典的象棋規則在 2D 格子中移動—車直行，象斜行，還有更多。但有一個轉折：向上移動也會讓你的棋子掉落！\n\n挑戰你的腦力：\n從簡單的關卡開始學習機械，然後挑戰越來越複雜的謎題。策略思考，解決創意挑戰以進階！",
      "instructions": "按照國際象棋規則移動您的棋子—車直行，象斜行等。\n記得：向上移動也會使您的棋子落下。\n通過達到目標並避開障礙來解謎。\n思考策略以完成越來越困難的關卡！",
      "genres": [
        "桌遊"
      ],
      "tags": [
        "圍棋",
        "國際象棋"
      ]
    },
    "zh-HK": {
      "title": "棋盤",
      "description": "在ChessField中掌握國際象棋棋子的移動！使用經典的國際象棋規則在2D格子上移動—車可以直行，主教可以斜行，還有更多。但有一個轉折：向上移動也會使你的棋子掉落！\n\n挑戰你的思維：\n從簡單的關卡開始學習機械，然後面對越來越複雜的謎題。深思熟慮並解決創新的挑戰，以進步！",
      "instructions": "移動你的棋子依照國際象棋規則—車走直線，象走對角線等。\n記住：向上移動同時會使你的棋子向下墜落。\n通過達到目標並避開障礙來解決謎題。\n展開策略思考以完成逐漸增加難度的關卡！",
      "genres": [
        "桌面遊戲"
      ],
      "tags": [
        "黑白棋",
        "國際象棋"
      ]
    },
    "ja": {
      "title": "チェスフィールド",
      "description": "チェスフィールドでマスター chess piece movements！古典的なチェスルールを使用して2Dグリッドをナビゲートする—ルークは直線に動く、ビショップは斜めに動くなど、さらに変わったルールも！しかし、一つだけ異なるルールがある：上に動くとその駒は落ちる！\n\n脳を鍛える：\n基本的なレベルから始めてメカニクスを学び、次第に難しくなるパズルに挑戦する。戦略的に考え、クリエイティブな課題を解決して進む！",
      "instructions": "チェスのルールに従ってあなたの駒を動かしてください—ルークは直線に、バishopsは斜めに動きます。\n覚えてください：上に動くことも駒を下に降ろすことになります。\n障害を避けながらゴールに到達してパズルを解いてください。\n戦略的に考えることで次第に難しいレベルをクリアしてください！",
      "genres": [
        "ボードゲーム"
      ],
      "tags": [
        "チェスケーカーズ"
      ]
    },
    "ko": {
      "title": "체스 필드",
      "description": "체스필드에서 마스터 체스 조각 이동을 배워보세요! 클래식 체스 규칙을 따라 2D 그리드를 탐험하세요—로크는 정직선으로, 비shop은 대각선으로 이동합니다. 하지만 돌발적인 요소가 있습니다: 위로 이동하면 조각이 떨어집니다!\n\n뇌를 도전하세요:\n기본 수준에서 기계적 원리를 배우고, 점점 더 어려운 퍼즐을 해결하세요. 전략적으로 생각하고, 창의적인 도전을 해결하여 진행하세요!",
      "instructions": "체스 규칙에 따라 기물을 이동하세요 — 캐스팅은 골라 이동, 비ショップ은 대각선으로 이동 등.\n기억하세요: 올라가는 것도 기물이 내려가는 것을 의미합니다.\n목표에 도달하면서 장애물을 피하여 퍼즐을 해결하세요.\n증가하는 난이도의 레벨을 완료하기 위해 전략적으로 생각하세요!",
      "genres": [
        "보드게임"
      ],
      "tags": [
        "체스",
        "체스"
      ]
    },
    "fr": {
      "title": "Champ d'échecs",
      "description": "Maîtrisez les mouvements des pièces d'échecs dans ChessField ! Naviguez sur une grille 2D en utilisant les règles classiques des échecs : les tours se déplacent en ligne droite, les fous en diagonale, et plus encore. Mais il y a un tour de passe-passe : se déplacer vers le haut fait également tomber votre pièce !\n\nDéfiez votre esprit :\nCommencez par des niveaux simples pour apprendre les mécanismes, puis affrontez des puzzles de plus en plus difficiles. Pensez stratégiquement et résolvez des défis créatifs pour progresser !",
      "instructions": "Déplacez votre pièce suivant les règles du jeu d'échecs — les tours se déplacent en ligne droite, les fous en diagonale, etc.\nRappelez-vous : se déplacer vers le haut fait aussi tomber votre pièce.\nRésolvez les puzzles en atteignant l'objectif tout en évitant les obstacles.\nPensez stratégiquement pour terminer des niveaux de plus en plus difficiles !",
      "genres": [
        "Jeux de plateau"
      ],
      "tags": [
        "Dames",
        "échecs"
      ]
    }
  }
};
